export const isTopCampaignTemplatesEnabled = false;
export const ROLES = {
  RECRUITER_MANAGER: "Recruiter Manager",
  RECRUITER: "Recruiter",
  SITE_LEADER: "Site Leader",
  CAMPAIGN_ADMIN: "Campaign Admin",
  NEWSFEED_ADMIN: "Newsfeed Admin",
  LEADERSHIP: "Leadership",
  COMPANY_ADMIN: "Company Admin",
  TALENT_ACQUISITION_HEAD: "Talent Acquisition Head",
  SUPER_ADMIN: "Super Admin",
  HIRING_MANAGER: "Hiring Manager",
  REPORT_ADMIN: "Report Admin",
  HR_OPS: "HR Ops",
  TA_DIRECTOR: "TA Director",
  SUPER_ADMIN_CAMPAIGN_MANAGER: "Super Admin Campaign Manager",
  CUSTOMER_SUCCESS: "Customer Success",
};

export const platformRolesDisassociatedFromCompany = [
  ROLES.CUSTOMER_SUCCESS,
];

export const PRIVILEGE_ACTION = Object.freeze({
  READ: "read",
  CREATE: "create",
  UPDATE: "update",
  DELETE: "delete",
});

export const PRIVILEGE_SLUG = Object.freeze({
  allUsers: "all_users",
  analytics: "analytics",
  allTasks: "all_tasks",
  campaignTemplates: "campaign_templates",
  candidates: "candidates",
  companies: "companies",
  dashboard: "dashboard",
  designations: "designations",
  employees: "employees",
  htmlTemplates: "html_templates",
  modifyCanvasIntegratedCompany: "modify_canvas_integrated_company",
  newsFeed: "news_feed",
  organizationJourneyManagement: "organization_journey_management",
  organizationManagement: "organization_management",
  positions: "positions",
  reports: "reports",
  tasks: "tasks",
  themes: "themes",
  settings: "settings",
  userManagement: "user_management",
});

export const PRIVILEGE_ALL_ACTIONS = Object.freeze([
  PRIVILEGE_ACTION.READ,
  PRIVILEGE_ACTION.CREATE,
  PRIVILEGE_ACTION.UPDATE,
  PRIVILEGE_ACTION.DELETE,
]);

export const OFFER_ROLLED_OUT = "Offer Rolled Out";
export const CANDIDATE_ROLE = "Candidate";
export const userErrorMessage = "Something went wrong";
export const magicLinkLoginNotificationChannel = "magicLinkLoginNotificationChannel"
export const candidateStatusList = [
  { value: "Offer Accepted", label: "Offer Accepted" },
  { value: "Offer Revoked", label: "Offer Revoked" },
  { value: "Offer Declined", label: "Offer Declined" },
  { value: "Joined", label: "Joined" },
  { value: "No Show", label: "No Show" },
  { value: "On hold", label: "On hold" },
  { value: "Deactivated", label: "Deactivated" },
];
export const iframeRegex = /^<iframe[\s\S]*<\/iframe>$/;
export const domoUrlRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;

// File sizes in mb
export const fileSizes = {
  dataFile: 25,
  image: 1,
  backgroundImage: 2
}
export const imageAcceptParameters = "image/png,image/jpg,image/jpeg,image/svg+xml,image/webp"
export const xlsxAcceptParameters = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
export const fileNameRegex = /^[a-zA-Z0-9_-]+\.[a-zA-Z0-9]+$/;
export const candidateStatus = [
  "Offer Accepted",
  "Joined",
  "Offer Revoked",
  "Offer Declined",
  "Offer Rejected",
  "On hold",
  "Deactivated",
  "No Show",
];
export const companyAdminPaths = [
  "/[slug]/admin/dashboard",
  "/[slug]/admin/mytask",
  "/[slug]/admin/candidates",
  "/[slug]/admin/positions",
  "/[slug]/admin/campaign-templates",
  "/[slug]/admin/journey-settings/my-journey",
  "/[slug]/admin/journey-settings/journey-templates",
  "/[slug]/admin/news-feeds",
  "/[slug]/admin/html-templates",
  "/[slug]/admin/survey-templates",
  "/[slug]/admin/quiz",
  "/[slug]/admin/users",
  "/[slug]/admin/themes",
  "/[slug]/admin/settings",
  "/[slug]/admin/auditlogs",
  "/[slug]/admin/employees",
  "/[slug]/admin/analytics",
]
export const recruiterPaths = [
  "/[slug]/admin/dashboard",
  "/[slug]/admin/mytask",
  "/[slug]/admin/candidates",
  "/[slug]/admin/positions",
  "/[slug]/admin/survey-templates",
  "/[slug]/admin/quiz",
  "/[slug]/admin/auditlogs",
  "/[slug]/admin/employees",
  "/[slug]/admin/analytics",
]
export const recruiterManagerPaths = [
  "/[slug]/admin/dashboard",
  "/[slug]/admin/mytask",
  "/[slug]/admin/candidates",
  "/[slug]/admin/positions",
  "/[slug]/admin/survey-templates",
  "/[slug]/admin/quiz",
  "/[slug]/admin/auditlogs",
  "/[slug]/admin/employees",
  "/[slug]/admin/analytics",
]
export const hiringManagerPaths = [
  "/[slug]/admin/candidates",
  "/hiring-manager-portal/candidates",
  "/[slug]/admin/positions",
  "/[slug]/admin/quiz",
  "/[slug]/admin/auditlogs",
  "/[slug]/admin/employees",
  "/[slug]/admin/analytics",
]
export const reportAdminPaths = [
  "/[slug]/admin/dashboard",
  "/[slug]/admin/survey-templates",
  "/[slug]/admin/quiz",
  "/[slug]/admin/analytics",
]
export const campaignAdminPaths = [
  // Need to remove below 2 lines if no issue in templatization prod & open the comments if old feature needs to be revoked
  // "/[slug]/admin/campaign-templates",
  // "/[slug]/admin/html-templates",
  "/[slug]/admin/journey-settings/my-journey",
  "/[slug]/admin/journey-settings/journey-templates",
  "/[slug]/admin/survey-templates",
  "/[slug]/admin/quiz",
  "/[slug]/admin/themes",
  "/[slug]/admin/analytics",
]
export const newsfeedAdminPaths = [
  "/[slug]/admin/news-feeds",
  "/[slug]/admin/survey-templates",
  "/[slug]/admin/quiz",
  "/[slug]/admin/analytics",
]
export const talentAcquisitionHeadPaths = [
  "/[slug]/admin/dashboard",
  "/[slug]/admin/mytask",
  "/[slug]/admin/candidates",
  "/[slug]/admin/positions",
  "/[slug]/admin/campaign-templates",
  "/[slug]/admin/designations",
  "/[slug]/admin/news-feeds",
  "/[slug]/admin/survey-templates",
  "/[slug]/admin/auditlogs",
  "/[slug]/admin/employees",
  "/[slug]/admin/analytics",
]
export const leadershipPaths = [
  "/[slug]/admin/dashboard",
  "/[slug]/admin/mytask",
  "/[slug]/admin/candidates",
  "/[slug]/admin/positions",
  "/[slug]/admin/campaign-templates",
  "/[slug]/admin/news-feeds",
  "/[slug]/admin/survey-templates",
  "/[slug]/admin/quiz",
  "/[slug]/admin/users",
  "/[slug]/admin/settings",
  "/[slug]/admin/auditlogs",
  "/[slug]/admin/employees",
  "/[slug]/admin/analytics",
]
export const hrOpsPaths = [
  "/[slug]/admin/dashboard",
  "/[slug]/admin/mytask",
  "/[slug]/admin/candidates",
  "/[slug]/admin/positions",
  "/[slug]/admin/quiz",
  "/[slug]/admin/auditlogs",
  "/[slug]/admin/employees",
  "/[slug]/admin/analytics",
]
export const siteLeaderPaths = [
  "/[slug]/admin/quiz",
  "/[slug]/admin/analytics",
]
export const taDirectorPaths = [
  "/[slug]/admin/dashboard",
  "/[slug]/admin/mytask",
  "/[slug]/admin/candidates",
  "/[slug]/admin/positions",
  "/[slug]/admin/quiz",
  "/[slug]/admin/auditlogs",
  "/[slug]/admin/employees",
  "/[slug]/admin/analytics",
]
export const superAdminCampaignManagerPaths = [
  "/superadmin/journey/touchpoints",
  "/superadmin/journey/templates",
  "/superadmin/journey/categories",
  "/[slug]/admin/analytics",
]
export const getApiRefetchTime = 1000 * 60 * 10; // 5 minutes
export const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const sessionExpiryTimeInSec = 3600;
export const otpResendTimeInSec = 30;
export const otpLength = 4;
export const mandatoryPlaceholders = [
  "{{{CANDIDATE_NAME}}}",
  "{{{POSITION_TITLE}}}",
  "{{{DOJ}}}",
  "{{{COMPANY_NAME}}}",
  "{{{RECRUITER_NAME}}}",
  "{{{CANDIDATE_ADDRESS}}}",
  "{{{TOUCHPOINT_TITLE}}}",
  "{{{CANDIDATE_URL}}}",
  "{{{CANDIDATE_NUMBER}}}",
  "{{{CANDIDATE_EMAIL}}}",
  "{{{CANDIDATE_TP_URL}}}",
  "{{{HIRING_MANAGER_NAME}}}",
  "{{{COMPANY_ADDRESS}}}",
  "{{{MEETING_TYPE}}}",
  "{{{MEETING_PERSON}}}",
  "{{{MEETING_LINK}}}",
  "{{{MEETING_LOCATION}}}",
  "{{{MEETING_DATE}}}",
  "{{{GOOGLE_MAPS_LINK}}}",
  "{{{DISPATCH_DATE}}}",
  "{{{DISPATCH_ADDRESS}}}",
  "{{{POINT_OF_CONTACT}}}",
  "{{{EMPLOYEE_HUB_LINK}}}",
  "{{{MEETING_TIME}}}",
];

export const placeholderData = [
  { placeholder: '{{{CANDIDATE_NAME}}}', description: 'To add the name of the candidate' },
  { placeholder: '{{{POSITION_TITLE}}}', description: 'To add the position title or position name' },
  { placeholder: '{{{DOJ}}}', description: 'To add the candidate’s Date Of Joining' },
  { placeholder: '{{{COMPANY_NAME}}}', description: 'To add the name of the company' },
  { placeholder: '{{{RECRUITER_NAME}}}', description: 'To add the respective recruiter’s name' },
  { placeholder: '{{{HIRING_MANAGER_NAME}}}', description: 'To add the respective hiring manager’s name' },
  { placeholder: '{{{COMPANY_ADDRESS}}}', description: 'To add the company address' },
  { placeholder: '{{{TOUCHPOINT_TITLE}}}', description: 'To add the title of the touch point' },
  { placeholder: '{{{CANDIDATE_NUMBER}}}', description: 'To add the mobile number of the candidate' },
  { placeholder: '{{{CANDIDATE_EMAIL}}}', description: 'To add candidate’s email address' },
  { placeholder: '{{{CANDIDATE_TP_URL}}}', description: 'To add the candidate portal or hub login link' },
  { placeholder: '{{{MEETING_TYPE}}}', description: 'To add the type of meeting assigned - in person or virtual meeting' },
  { placeholder: '{{{MEETING_PERSON}}}', description: 'To add the meeting person for the candidate - recruiter or hiring manager' },
  { placeholder: '{{{MEETING_LINK}}}', description: 'To add the meeting link to the meeting' },
  { placeholder: '{{{MEETING_LOCATION}}}', description: 'To add the in person meeting location' },
  { placeholder: '{{{MEETING_DATE}}}', description: 'To add the meeting date assigned' },
  { placeholder: '{{{MEETING_TIME}}}', description: 'To add the confirmed meeting date and time slot' }
];

export const quizComingSoonMessage = "Quiz is coming soon! Stay tuned for updates."

export const engagementScore = {
  coldMin: 0,
  coldMax: 20,
  warmMin: 21,
  warmMax: 59,
  hotMin: 60,
  hotMax: 100,
}

export const sendReminderAllowedRoles = [
  "Super Admin",
  "Recruiter",
  "Recruiter Manager",
  "TA Director",
  "Customer Success"
];

export const ALLOWED_ROLES_FOR_RETRIGGER_MEETING_SLOTS_LINK = [
  "Recruiter",
  "Recruiter Manager", 
  "TA Director",
  "Company Admin",
  "Super Admin",
  "Customer Success"
];

// Default speed at which content is read (For touchpoint body)
export const wpm = 225;

export const rolesHigherThanRecAndRecruiterManager = [
  ROLES.SUPER_ADMIN,
  ROLES.COMPANY_ADMIN,
  ROLES.TA_DIRECTOR,
  ROLES.HR_OPS,
  ROLES.TALENT_ACQUISITION_HEAD,
  ROLES.CUSTOMER_SUCCESS
];

export const INDIA_COUNTRY_CODE = 91;

export const TOAST_IDS = {
  INIT_AUTH: "exotel-init-auth-error-toast",
  OUTBOUND_CALL: "exotel-outbound-call-error-toast",
  USER_MAPPING: "exotel-user-mapping-error-toast",
};

export const ERROR_MESSAGES = {
  INIT_AUTH:
    "We couldn’t place the call due to a technical error. Please contact your administrator for assistance.",
  OUTBOUND_CALL:
    "Calling feature is temporarily unavailable. Please try again in a few minutes or contact administrator if the issue continues.",
  USER_MAPPING:
    "Your account doesn't have calling privileges. Please contact your administrator to enable calling access.",
};

export const metricTypeNameMap = {
  opened_email: "Read Mail",
  clicked_link: "Clicked Embedded Links",
  signed_in: "Signed In",
  engagement_time: "Engagement Time",
  recruiter_feedback: "Meeting Person Feedback",
  opened_survey: "Viewed Survey",
  survey_answered: "Answered the survey",
  opened_quiz:"Viewed Quiz",
  quiz_answered:"Answered the Quiz",
  meeting_scheduled: "Meeting Scheduled",
  meeting_attended: "Meeting Attended",
  candidate_unavailable: "Candidate Unavailable",
};

export const candidateMeetingStatusList = [
  {
    value: "candidate_not_available",
    label: "Candidate Unavailable",
  },
  {
    value: "no_meeting_link",
    label: "Meeting Link Unavailable",
  },
  {
    value: "host_not_available",
    label: "Meeting Person Unavailable",
  },
  {
    value: "meeting_scheduled",
    label: "Meeting Scheduled",
  },
  {
    value: "slots_alloted",
    label: "Slots Alloted",
  },
  {
    value: "reminder_sent",
    label: "Slot scheduling mail triggered - Meeting Email Sent",
  },
  {
    value: "no_reminder_sent",
    label: "To Be Initiated",
  },
];

export const AUDIT_LOG_PROPERTIES_TO_DELETE = [
  'updated_at',
  'confidence_score',
  'previous_position_id',
  'whatsapp_message_id',
  'survey_questions',
  'survey_answers',
  'quiz_questions',
  'quiz_answers',
  'body',
  'email_body',
  'campaign_instance_id',
  'design_data',
  'html',
  'is_employee'
];

export const LOGIN_THEME_TEMPLATE_MAP = {
  none: "template1",
  bottom: "template2",
  top: "template3",
};

export const LOGIN_THEME_TEMPLATE_ID_MAP = {
  template1: "none",
  template2: "bottom",
  template3: "top",
};

export const DEFAULT_WHITE_COLOR = "rgba(255,255,255,1)";

export const LOGIN_THEME_PREVIEW_TABS = [
  { id: "phone", label: "Phone" },
  { id: "otp", label: "OTP" },
  { id: "desktop", label: "Desktop" },
  { id: "mobile", label: "Mobile" },
];

export const LOGIN_THEME_TEMPLATES = [
  {
    id: "template1",
    title: "Template 1",
    subtitle: "Minimal Login-First Template",
  },
  {
    id: "template2",
    title: "Template 2",
    subtitle: "Discovery Template - Hero image with bottom-aligned text",
  },
  {
    id: "template3",
    title: "Template 3",
    subtitle: "Branded Template - Hero image with top-aligned text",
  },
];

export const ENGAGEMENT_BADGES = [
  {
    key: "hot",
    label: "Hot",
    bgClass: "bg-hot",
    icon: "/images/icons/hot.svg",
    countKey: "hotCount",
  },
  {
    key: "warm",
    label: "Warm",
    bgClass: "bg-warm",
    icon: "/images/icons/warm.svg",
    countKey: "warmCount",
  },
  {
    key: "cold",
    label: "Cold",
    bgClass: "bg-cold",
    icon: "/images/icons/cold.svg",
    countKey: "coldCount",
  },
];

/**
 * JSON `filters` query for /hiring-manager-portal/candidates.
 * `portalListView` selects the backend query (slots_pending | scheduled | feedback_pending); legacy
 * `meetingSlotBeforeToday` / `meetingSlotOnOrAfterToday` still map for old bookmarks.
 */
export const HIRING_MANAGER_PORTAL_SUMMARY_CARDS = [
  {
    key: "total",
    label: "TOTAL",
    icon: "/images/icons/users-o.svg",
    leftBarColor: "bg-gray-300",
    listFilters: null,
  },
  {
    key: "slotsPending",
    label: "SLOTS PENDING",
    icon: "/images/icons/calendar-g.svg",
    leftBarColor: "bg-info",
    listFilters: { portalListView: "slots_pending", meetingStatus: ["reminder_sent"] },
  },
  {
    key: "scheduled",
    label: "SCHEDULED",
    icon: "/images/icons/calender-task-o.svg",
    leftBarColor: "bg-paleGreen",
    listFilters: {
      portalListView: "scheduled",
      meetingStatus: ["meeting_scheduled"],
    },
  },
  {
    key: "feedbackPending",
    label: "FEEDBACK PENDING",
    icon: "/images/icons/feedback-pending.svg",
    leftBarColor: "bg-purple",
    listFilters: {
      portalListView: "feedback_pending",
      meetingStatus: ["meeting_scheduled"],
    },
  },
];

export const HIRING_MANAGER_PORTAL_ENGAGEMENT_LIST_FILTERS = {
  hot: { engagementLevel: "hot" },
  warm: { engagementLevel: "warm" },
  cold: { engagementLevel: "cold" },
};

/** Help & tutorials route for the HM portal dashboard CTA. */
export const HIRING_MANAGER_PORTAL_HELP_PAGE_PATH = "/hiring-manager-portal/help";

export const HIRING_MANAGER_PORTAL_HELP_PDF_S3_KEY =
  "hiring-manager-portal/1_connect_hiring_manager_connect___new_hiring_manager-guide.pdf";

export const HIRING_MANAGER_PORTAL_HELP_ICONS = {
  question: "/images/icons/hm-help-question.svg",
  chevronLeft: "/images/icons/hm-help-chevron-left.svg",
  externalLink: "/images/icons/hm-help-external-link.svg",
  guide: "/images/icons/hm-help-guide.svg",
  download: "/images/icons/hm-help-download.svg",
  play: "/images/icons/hm-help-play.svg",
  arrowRight: "/images/icons/arrow-right.svg",
};

export const HIRING_MANAGER_PORTAL_HELP_RESOURCES = {
  interactiveGuide: {
    href: "https://talent500.portal.trainn.co/share/tKGc1NFeQMhWE4md01K7oQ",
    title: "Interactive step-by-step guide",
    description: "Click through the platform at your own pace.",
    iconSrc: HIRING_MANAGER_PORTAL_HELP_ICONS?.guide,
    trailingIconSrc: HIRING_MANAGER_PORTAL_HELP_ICONS?.externalLink,
    iconVariant: "guide",
  },
  pdfGuide: {
    s3FilePath: HIRING_MANAGER_PORTAL_HELP_PDF_S3_KEY,
    download: "1Connect-Hiring-Manager-Guide.pdf",
    title: "Download PDF guide",
    description: "Keep the full Hiring Manager handbook offline.",
    iconSrc: HIRING_MANAGER_PORTAL_HELP_ICONS.download,
    trailingIconSrc: HIRING_MANAGER_PORTAL_HELP_ICONS.download,
    iconVariant: "guide",
  },
videos: [
    {
      href: "https://talent500.portal.trainn.co/share/UrUbsmcYEJ6t7PY7vm7eOA",
      title: "Platform overview",
      description: "A short tour of your Hiring Manager dashboard.",
      iconSrc: HIRING_MANAGER_PORTAL_HELP_ICONS?.play,
      trailingIconSrc: HIRING_MANAGER_PORTAL_HELP_ICONS?.externalLink,
      iconVariant: "video",
    },
    {
      href: "https://talent500.portal.trainn.co/share/eRzJMO0Zb0n6ADX50FDoFg",
      title: "Provide Slots",
      description: "How to share your availability for interviews.",
      iconSrc: HIRING_MANAGER_PORTAL_HELP_ICONS?.play,
      trailingIconSrc: HIRING_MANAGER_PORTAL_HELP_ICONS?.externalLink,
      iconVariant: "video",
    },
    {
      href: "https://talent500.portal.trainn.co/share/tSjaO6x3dG6xGMjquBX3vA",
      title: "Provide Feedback",
      description: "How to submit feedback after a connect.",
      iconSrc: HIRING_MANAGER_PORTAL_HELP_ICONS?.play,
      trailingIconSrc: HIRING_MANAGER_PORTAL_HELP_ICONS?.externalLink,
      iconVariant: "video",
    },
  ],
};

/** Nav tabs for `TabbedHeader` on hiring-manager-portal routes (shared Dashboard / My Candidates). */
export const getHiringManagerPortalNavTabs = (router) => [
  {
    key: "dashboard",
    label: "Dashboard",
    onClick: () => router.push("/hiring-manager-portal"),
  },
  {
    key: "candidates",
    label: "My Candidates",
    onClick: () => router.push("/hiring-manager-portal/candidates"),
  },
];

export const HIRING_MANAGER_PORTAL_FILTER_IDS = {
  POSITION: 'position',
  DATE_OF_JOINING: 'dateOfJoining',
  RECRUITERS: 'recruiters',
};

export const getHiringManagerPortalFilterConfig = (rolesOptions = [], recruitersOptions = []) => ({
  filters: [
    {
      id: HIRING_MANAGER_PORTAL_FILTER_IDS.POSITION,
      label: 'Position',
      type: 'multiselect',
      options: rolesOptions,
      placeholder: 'All positions',
    },
    {
      id: HIRING_MANAGER_PORTAL_FILTER_IDS.DATE_OF_JOINING,
      label: 'Date of Joining',
      type: 'daterange',
      placeholder: 'All dates',
    },
    {
      id: HIRING_MANAGER_PORTAL_FILTER_IDS.RECRUITERS,
      label: 'Recruiter',
      type: 'multiselect',
      options: recruitersOptions,
      placeholder: 'All recruiters',
    },
  ],
});

// Roles to exclude from PostHog tracking
export const EXCLUDED_ROLES_FROM_POSTHOG_TRACKING = [ROLES.SUPER_ADMIN, ROLES.SUPER_ADMIN_CAMPAIGN_MANAGER];

// PostHog analytics event names
export const AnalyticsEvents = {
  // Hiring Manager Portal Events
  HIRING_MANAGER_PORTAL_DASHBOARD_VIEWED: 'hiring_manager_portal_dashboard_viewed',
  HIRING_MANAGER_PORTAL_HELP_CLICKED: 'hiring_manager_portal_help_clicked',

  // User Management Events
  USER_LOGGED_IN: 'user_logged_in',

  // Search & Discovery
  SEARCH_PERFORMED: 'search_performed',
  CANDIDATE_PROFILE_VIEWED: 'candidate_profile_viewed',

  // Dashboard Interactions
  DASHBOARD_HOT_CLICKED: 'dashboard_hot_clicked',
  DASHBOARD_WARM_CLICKED: 'dashboard_warm_clicked',
  DASHBOARD_COLD_CLICKED: 'dashboard_cold_clicked',

  // Communication
  CALL_INITIATED: 'call_initiated',

  // Interventions
  INTERVENTION_SUBMITTED: 'intervention_submitted',

  // Candidate Hub (for candidates)
  QUIZ_VIEWED: 'quiz_viewed',
  SURVEY_VIEWED: 'survey_viewed',
  CANDIDATE_HUB_VIEWED: 'candidate_hub_viewed',

  // Help & Resources
  KNOWLEDGE_HUB_CLICKED: 'knowledge_hub_clicked',
  HELP_WIDGET_CLICKED: 'help_widget_clicked',
};
